import MarketingPage from './MarketingPage';

export type { TMarketingTabname } from './hooks/useTabSelected';

export default MarketingPage;
